import axios from 'axios';

export const getBooks = async () => {
    try {
        const response = await axios.get('/api/books');
        return response.data;
    } catch (error) {
        console.error('Error fetching books:', error);
        throw error;
    }
}

export const getBookById = async (id) => {
    try {
        const response = await axios.get(`/api/books/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching book by ID:', error);
        throw error;
    }
}
